import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusState } from "store/types";
import { fetchVolunteers } from "./volunteers.actions";
import { initialState } from "./volunteers.initial-state";
import { Volunteer } from "./volunteers.types";

const volunteersSlice = createSlice({
  name: "volunteers",
  initialState,
  reducers: {
    setVolunteers: (state, action: PayloadAction<Volunteer[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Volunteers
      .addCase(fetchVolunteers.pending, (state) => {
        state.status = StatusState.LOADING;
        state.error = null;
      })
      .addCase(fetchVolunteers.fulfilled, (state) => {
        state.status = StatusState.SUCCEEDED;
      })
      .addCase(fetchVolunteers.rejected, (state, action) => {
        state.status = StatusState.FAILED;
        state.error = action.error.message || "Failed to fetch attending events";
      });
  },
});

export const { setVolunteers } = volunteersSlice.actions;
const volunteersReducer = volunteersSlice.reducer;
export default volunteersReducer;

